module.exports = __webpack_public_path__ + "img/table-foreign-icon.cff65736.svg";